import { Images } from "@assets/images";
import { Form, Formik } from "formik";
import { FormControl } from "../form-control";
import Input from "../input";
import Button from "../button";
import { createConfirmOtpValidationSchema } from "@app/validations";
import { PortalDialogProps } from "@app/services/modal.service";
import Modal from "../modal/modal.component";
import { InfoConfirmOtp } from "@app/types";
import AuthService from "@app/services/http/auth.service";
import { addToast } from "../toast/toast.service";

interface OtpConfirmProps {
  infoConfirmOtp?: InfoConfirmOtp;
}

interface FormValues {
  otp: string;
  password: string;
}

const maskEmail = (email?: string): string => {
  if (!email) return "N/A";

  const [firstPart, domain] = email.split("@");

  return `***${firstPart.slice(3)}@${domain}`;
};

const OtpConfirmModal = ({
  portalDialogRef,
  portalData,
}: PortalDialogProps<OtpConfirmProps>) => {
  const canSendOtpToPhone = portalData?.infoConfirmOtp?.canSendToPhone;

  const onSubmit = (values: FormValues) => {
    if (values.otp && values.password) {
      portalDialogRef.close({
        otp: values.otp,
        password: values.password,
      });
    }
  };

  const handleResendOtp = () => {
    const username = portalData?.infoConfirmOtp?.username;

    if (!username) {
      return;
    }

    AuthService.forgotPassword(username).then((res) => {
      addToast({ text: res.data.message });
    });
  };

  const handleSendToPhone = () => {
    const username = portalData?.infoConfirmOtp?.username;
    const isSendToPhone = portalData?.infoConfirmOtp?.canSendToPhone;

    if (!username || !isSendToPhone) {
      return;
    }

    AuthService.forgotPassword(username, isSendToPhone).then((res) => {
      addToast({ text: res.data.message });
    });
  };

  return (
    <Modal onCancel={portalDialogRef.close}>
      <div className="w-[443px] px-[34px] py-10 bg-white rounded-xl">
        <div className="flex justify-center">
          <img className="w-28" src={Images.LogoText.default} alt="Logo" />
        </div>
        <div className="mt-4 font-[SVN-Gilroy] font-semibold text-xl text-center text-neutral-n80">
          Quên mật khẩu
        </div>
        <div className="mt-2 text-sm text-center mb-10 text-black-30 font-[SVN-Gilroy] font-medium">
          Nhập thông tin để thay đổi mật khẩu
        </div>
        <div className="flex justify-between items-center">
          <div className="font-[SVN-Gilroy] text-[16px] mt-4">
            <h3 className="font-[SVN-Gilroy]">Mã OTP đã được gửi về email</h3>
            <p className="text-[#4667CA] mt-2">
              {portalData?.infoConfirmOtp?.email
                ? maskEmail(portalData.infoConfirmOtp.email)
                : "Email not available"}
            </p>
          </div>
        </div>

        <div className="flex justify-between mt-6 font-[SVN-Gilroy] text-[16px]">
          <h3 className="font-[SVN-Gilroy]">Bạn có thể nhận lại OTP</h3>
          <h3
            onClick={handleResendOtp}
            className="text-[#4667CA] text-[14px] font-semibold font-[SVN-Gilroy] cursor-pointer"
          >
            Nhận lại OTP
          </h3>
        </div>
        <Formik
          initialValues={{
            otp: "",
            password: "",
          }}
          onSubmit={onSubmit}
          validationSchema={createConfirmOtpValidationSchema}
          validateOnBlur
          validateOnChange
        >
          <Form>
            <div className="mt-4">
              <FormControl name="otp">
                <Input
                  placeholder="Nhập mã OTP"
                  inputClassName="font-[SVN-Gilroy] font-medium !text-[#272C36] tracking-[0.024px]"
                  errorClassName="font-[SVN-Gilroy] tracking-[0.024px]"
                />
              </FormControl>
            </div>
            <div className="mt-4">
              <FormControl name="password">
                <Input
                  type="password"
                  placeholder="Mật khẩu mới"
                  inputClassName="font-[SVN-Gilroy] font-medium !text-[#272C36] tracking-[0.024px]"
                  errorClassName="font-[SVN-Gilroy] tracking-[0.024px]"
                  inputIconClassName="!w-[18px] !h-[18px]"
                />
              </FormControl>
            </div>
            <div className="mt-4">
              <FormControl name="confirmPassword">
                <Input
                  type="password"
                  placeholder="Nhập lại mật khẩu mới"
                  inputClassName="font-[SVN-Gilroy] font-medium !text-[#272C36] tracking-[0.024px]"
                  errorClassName="font-[SVN-Gilroy] tracking-[0.024px]"
                  inputIconClassName="!w-[18px] !h-[18px]"
                />
              </FormControl>
              {canSendOtpToPhone && (
                <div className="flex justify-end mt-4">
                  <h3
                    onClick={handleSendToPhone}
                    className="text-[#4667CA] text-[14px] font-semibold font-[SVN-Gilroy] cursor-pointer"
                  >
                    Nhận mã OTP qua SMS
                  </h3>
                </div>
              )}
            </div>
            <Button
              type="submit"
              containerClassName="mt-10 mx-auto"
              label="Tiếp tục"
              labelClassName="font-[SVN-Gilroy]"
              width=""
              size="l"
              className="text-lg font-bold px-11 rounded-3xl"
            />
          </Form>
        </Formik>
      </div>
    </Modal>
  );
};

export default OtpConfirmModal;
